import * as React from "react";
import styled from "react-emotion";
import { theme } from "../../styles/theme";

const Wrap = styled.div`
  position: relative;
  height: ${props => props.height}px;
  width: ${props => props.height}px;
`;
const ChildWrap = styled.div`
  position: relative;
  left: 0;
  top: 0;
  height: ${props => props.height}px;
  width: ${props => props.height}px;
  border-radius: 50%;
  overflow: hidden;
  transform: scale(0.7) translateX(-0.7em);
  transform-origin: center center;
`;

const Letter = styled.span`
  font-family: ${theme.mono.fontFamily};
  font-weight: ${theme.mono.fontWeight};
  line-height: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: ${props => 180 / (props.length - 1)}px;
  height: ${props => props.height}px;
  transform: translateX(${props =>
    -(180 / (props.length - 1)) + props.height / 2}px) rotate(${props =>
  props.offset + 180 / (props.length - 1) * props.index}deg);
  transform-origin: center center;
}
`;

const CirleIcon = ({
  offset = -90,
  height = 150,
  text = "",
  text2,
  divider = "•",
  children
}) => {
  const dividedText = divider + text + divider;
  const dividedText2 = " " + (text2 || text) + " ";
  return (
    <Wrap height={height}>
      {dividedText.split("").map((x, k) => (
        <Letter
          key={k}
          index={k}
          offset={offset}
          height={height}
          length={dividedText.length}
        >
          {x}
        </Letter>
      ))}
      {dividedText2.split("").map((x, k) => (
        <Letter
          key={k}
          index={k}
          offset={offset + 180}
          height={height}
          length={dividedText.length}
        >
          {x}
        </Letter>
      ))}
      {children && <ChildWrap height={height}>{children}</ChildWrap>}
    </Wrap>
  );
};

export default CirleIcon;



// WEBPACK FOOTER //
// ./src/components/CircleIcon/index.js